import React from 'react';
import PropTypes from 'prop-types';
import TVWeeklySummaryPanel from './TVWeeklySummaryPanel';

function TVPreviousWeekPanel({ data, compact = false, loading = false }) {
  return <TVWeeklySummaryPanel data={data} compact={compact} loading={loading} />;
}

TVPreviousWeekPanel.propTypes = {
  data: PropTypes.object,
  compact: PropTypes.bool,
  loading: PropTypes.bool,
};

export default TVPreviousWeekPanel;
